<template>
  <notes
    description="General Notes related to this Staff Member"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    staff: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "staff"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.staff.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
